import {HttpClient} from "@angular/common/http";
import {Injectable} from "@angular/core";
import {Observable} from "rxjs";
import {environment} from "../../../environments/environment";
import {ServiceLocationRegistrationRelations} from "../../models/service_location_registration_relations";
import Helpers from "../../utils/helpers";

@Injectable()
export class ServiceLocationRegistrationsControllerService {

  private baseUrl: string = environment.BASE_URL;

  constructor(private http: HttpClient) {
  }

  public getServicelocationsRegistrationsRelationsList(serviceId: string): Observable<ServiceLocationRegistrationRelations[][]> {
    return this.http.get(this.baseUrl + "service/" + serviceId + "/service_location_registration") as Observable<ServiceLocationRegistrationRelations[][]>;
  }

  public saveServiceLocationRegistrations(serviceId: string, costRegistrationRelations: ServiceLocationRegistrationRelations) {
    Helpers.trimRecursiveObj(costRegistrationRelations);
    const body = JSON.stringify(costRegistrationRelations);
    return this.http.post(this.baseUrl + "service_location_registration", body);
  }

}
